/**
 * «Неактивен» без спроса, как в Discord: 10 минут без клавиатуры и мыши в этом окне — человек
 * отошёл, первое же движение — вернулся. Отметка уходит в шлюз (op 3); сервер показывает
 * «неактивен», только если отошли все сессии и человек сам выбрал «в сети» — ручные
 * «неактивен», «не беспокоить» и «невидимый» она не перебивает.
 *
 * Пока идёт звонок или запущена игра, человек не «отошёл», даже если окна не касается:
 * слушает собеседников или играет. Браузеру другие окна не видны, поэтому игру сообщает оболочка.
 */
export const IDLE_AFTER = 10 * 60_000
const CHECK_EVERY = 15_000
const INPUT = ['pointerdown', 'pointermove', 'keydown', 'wheel', 'touchstart'] as const

export function startIdleWatch(onChange: (idle: boolean) => void, busy: () => boolean): () => void {
  let last = Date.now()
  let idle = false
  const active = () => {
    last = Date.now()
    if (idle) {
      idle = false
      onChange(false)
    }
  }
  for (const e of INPUT) window.addEventListener(e, active, { capture: true, passive: true })
  window.addEventListener('focus', active)
  const timer = setInterval(() => {
    if (busy()) {
      active()
      return
    }
    if (!idle && Date.now() - last >= IDLE_AFTER) {
      idle = true
      onChange(true)
    }
  }, CHECK_EVERY)
  return () => {
    clearInterval(timer)
    for (const e of INPUT) window.removeEventListener(e, active, { capture: true })
    window.removeEventListener('focus', active)
  }
}
